import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/presentations/presentations/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Button } from '@primer/components';
import { HeroLayout } from '@primer/gatsby-theme-doctocat';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = HeroLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p>{`Primer Presentations is the presentation design system for GitHub. This repo contains the presentation templates, guidelines, and assets needed to create presentations that represent the GitHub brand.`}</p>
    <Note variant="warning" mdxType="Note">
      <p>{`The Primer presentation design system is intended to be used `}<em parentName="p"><strong parentName="em">{`only`}</strong></em>{` by GitHub staff for presentations that
represent GitHub.`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      